'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _deepDiff = require('deep-diff');

var _deepDiff2 = _interopRequireDefault(_deepDiff);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TYPE_OPTIONS = [{ value: 'admin', label: 'Admin' }, { value: 'data-admin', label: 'Data Admin' }, { value: 'reporter', label: 'Reporter' }, { value: 'directory-user', label: 'Directory User' }];

var ACS = function (_React$Component) {
	_inherits(ACS, _React$Component);

	function ACS(props) {
		_classCallCheck(this, ACS);

		var _this = _possibleConstructorReturn(this, (ACS.__proto__ || Object.getPrototypeOf(ACS)).call(this, props));

		_this.state = {
			currentTab: 1,

			dataPoints: {
				regions: false,
				brands: false,
				stores: false
			},
			dataLoaded: false,
			groups: JSON.parse(JSON.stringify(ACS_GROUPS))
		};

		_this.hasChanges = _this._hasChanges.bind(_this);
		_this.handleTabChange = _this._handleTabChange.bind(_this);
		_this.handleAddGroup = _this._handleAddGroup.bind(_this);
		_this.handleTypeChange = _this._handleTypeChange.bind(_this);
		_this.handleTitleChange = _this._handleTitleChange.bind(_this);
		_this.renderOptionGroup = _this._renderOptionGroup.bind(_this);
		_this.renderSaveButton = _this._renderSaveButton.bind(_this);
		_this.handleSave = _this._handleSave.bind(_this);
		_this.handleCheckboxChange = _this._handleCheckboxChange.bind(_this);
		_this.getCurrentGroupSelection = _this._getCurrentGroupSelection.bind(_this);
		_this.isAdmin = _this._isAdmin.bind(_this);
		_this.loadDataPoint = _this._loadDataPoint.bind(_this);
		_this.handleDataPointLoaded = _this._handleDataPointLoaded.bind(_this);
		_this.isAllLoaded = _this._isAllLoaded.bind(_this);
		_this.loadData.bind(_this)();

		return _this;
	}

	_createClass(ACS, [{
		key: '_isAdmin',
		value: function _isAdmin() {
			return this.state.groups[this.state.currentTab].type === 'admin';
		}
	}, {
		key: 'loadData',
		value: function loadData() {
			var _this2 = this;

			Object.keys(this.state.dataPoints).forEach(function (key) {
				return _this2.loadDataPoint(key);
			});
		}
	}, {
		key: '_loadDataPoint',
		value: function _loadDataPoint(type) {
			var _this3 = this;

			var url = '/ajax/' + type;
			var request = new Request(url, {
				credentials: 'same-origin',
				method: 'GET'
			});

			fetch(request).then(function (response) {
				return response.json();
			}).then(function (response) {
				return _this3.handleDataPointLoaded(type, response);
			});
		}
	}, {
		key: '_handleDataPointLoaded',
		value: function _handleDataPointLoaded(type, data) {
			var dataPoints = _extends({}, this.state.dataPoints);
			dataPoints[type] = data;

			this.setState({
				dataPoints: dataPoints
			});

			this.isAllLoaded();
		}
	}, {
		key: '_isAllLoaded',
		value: function _isAllLoaded() {
			var this$1 = this;


			var valid = true;

			for (var key in this.state.dataPoints) {
				if (this$1.state.dataPoints.hasOwnProperty(key)) continue;
				if (this$1.state.dataPoints.hasOwnProperty(key) === false) valid = false;
			}

			this.setState({
				dataLoaded: valid
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'acs' },
				this.renderErrors.bind(this)(),
				_react2.default.createElement(
					'div',
					{ className: 'acs-tabs' },
					this.renderTabs.bind(this)(),
					_react2.default.createElement(
						'div',
						{ className: 'tab add-new', onClick: this.handleAddGroup },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'+'
						)
					),
					this.renderOptions.bind(this)()
				)
			);
		}
	}, {
		key: 'renderErrors',
		value: function renderErrors() {
			var hasError = this.state.hasError;
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("acs-error bg-danger", { show: hasError }) },
				'Please save before changing tabs. ',
				_react2.default.createElement(
					'a',
					{ href: '#', onClick: this.handleChangeAnyway },
					'Discard changes and change tab.'
				)
			);
		}
	}, {
		key: 'renderTabs',
		value: function renderTabs() {
			var _this4 = this;

			return this.state.groups.map(function (group, i) {
				return _react2.default.createElement(
					'div',
					{
						className: (0, _classnames2.default)("tab", { 'active': _this4.state.currentTab == i }),
						key: i,
						onClick: _this4.handleTabChange(i)
					},
					_react2.default.createElement(
						'div',
						{ className: 'title' },
						group.name,
						'\xA0'
					)
				);
			});
		}
	}, {
		key: 'renderOptions',
		value: function renderOptions() {
			var _this5 = this;

			if (!this.state.dataLoaded) {
				return _react2.default.createElement(
					'div',
					{ className: 'acs-options', key: 'acs-options' },
					_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin fa-3x fa-fw' })
				);
			}

			var _state$groups$state$c = this.state.groups[this.state.currentTab],
			    name = _state$groups$state$c.name,
			    type = _state$groups$state$c.type;


			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("acs-options", { 'is-admin': type == 'admin' }) },
				_react2.default.createElement(
					'div',
					{ className: 'pull-right' },
					this.renderSaveButton()
				),
				_react2.default.createElement(
					'div',
					{ className: 'input-group' },
					_react2.default.createElement(
						'label',
						{ htmlFor: 'acs-item-title' },
						'Title'
					),
					' ',
					_react2.default.createElement('input', {
						type: 'text',
						name: 'title',
						id: 'acs-item-title',
						placeholder: 'Title',
						value: name,
						onChange: this.handleTitleChange,
						ref: function ref(e) {
							_this5.titleInput = e;
						}
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'input-group' },
					_react2.default.createElement(
						'label',
						{ htmlFor: 'acs-item-title' },
						'Type'
					),
					_react2.default.createElement(_reactSelect2.default, {
						clearable: false,
						searchable: false,
						value: type,
						options: TYPE_OPTIONS,
						onChange: this.handleTypeChange
					})
				),
				_react2.default.createElement('hr', null),
				Object.keys(this.state.dataPoints).map(function (key) {
					return [_this5.renderOptionGroup(key), _react2.default.createElement('hr', { key: 'hr' + key })];
				})
			);
		}
	}, {
		key: '_hasChanges',
		value: function _hasChanges() {
			return false;
			return !!(0, _deepDiff2.default)(this.state.groups[this.state.currentTab], ACS_GROUPS[this.state.currentTab]);
		}
	}, {
		key: '_renderSaveButton',
		value: function _renderSaveButton() {
			// const show = this.hasChanges();
			var show = true;
			return _react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)("btn btn-success ix-save", { show: show }),
					onClick: this.handleSave
				},
				'Save'
			);
		}
	}, {
		key: '_getCurrentGroupSelection',
		value: function _getCurrentGroupSelection(type) {
			return this.state.groups[this.state.currentTab].definition[type];
		}
	}, {
		key: '_renderOptionGroup',
		value: function _renderOptionGroup(type) {
			var _this6 = this;

			var items = this.state.dataPoints[type];
			if (!items) return null;

			var isAdmin = this.isAdmin();
			var selected = (this.getCurrentGroupSelection(type) || []).map(function (v) {
				return parseInt(v);
			});

			return _react2.default.createElement(
				'div',
				{ className: 'option-group', key: type },
				_react2.default.createElement(
					'div',
					{ className: 'title' },
					type
				),
				_react2.default.createElement(
					'div',
					{ className: 'options' },
					items.map(function (item, i) {
						var name = type + "[" + item.value + "]";
						var checked = isAdmin || selected.indexOf(item.value) !== -1;
						return _react2.default.createElement(
							'div',
							{ className: 'option', key: i },
							_react2.default.createElement('input', {
								onChange: _this6.handleCheckboxChange(type),
								type: 'checkbox',
								name: name,
								id: name,
								checked: checked,
								value: item.value
							}),
							' ',
							_react2.default.createElement(
								'label',
								{ htmlFor: name },
								item.label
							)
						);
					})
				)
			);
		}
	}, {
		key: '_handleCheckboxChange',
		value: function _handleCheckboxChange(type, checked) {

			return function (e) {
				var groups = this.state.groups;
				var currentGroup = _extends({}, groups[this.state.currentTab]);
				var definition = currentGroup.definition;

				if (typeof definition[type] === 'undefined') definition[type] = [];
				var value = parseInt(e.target.value, 10);
				if (e.target.checked) {
					definition[type].push(value);
				} else {
					var itemIndex = definition[type].indexOf(value);
					definition[type].splice(itemIndex);
					if (definition[type].length === 0) delete definition[type];
				}

				this.setState({
					groups: [].concat(_toConsumableArray(groups.slice(0, this.state.currentTab)), [currentGroup], _toConsumableArray(groups.slice(this.state.currentTab + 1)))
				});
			}.bind(this);
		}
	}, {
		key: '_handleTitleChange',
		value: function _handleTitleChange(e) {
			var groups = [].concat(_toConsumableArray(this.state.groups));
			groups[this.state.currentTab].name = e.target.value;
			this.setState({
				groups: groups
			});
		}
	}, {
		key: '_handleTypeChange',
		value: function _handleTypeChange(value) {
			var groups = [].concat(_toConsumableArray(this.state.groups));
			groups[this.state.currentTab].type = value.value;
			this.setState({
				groups: groups
			});
		}
	}, {
		key: '_handleTabChange',
		value: function _handleTabChange(index) {
			return function () {

				if (this.hasChanges()) {
					this.setState({
						attemptedTab: index,
						hasError: true
					});
					return;
				}

				this.setState({
					currentTab: index
				});
			}.bind(this);
		}
	}, {
		key: '_handleAddGroup',
		value: function _handleAddGroup() {
			var groups = [].concat(_toConsumableArray(this.state.groups), [{
				name: 'New Group',
				type: 'user',
				definition: {}
			}]);
			var that = this;
			this.setState({
				groups: groups,
				currentTab: groups.length - 1
			}, function () {
				setTimeout(function () {
					that.titleInput.focus();
					that.titleInput.setSelectionRange(0, that.titleInput.value.length);
				}, 100);
			});
		}
	}, {
		key: '_handleSave',
		value: function _handleSave() {
			var _state = this.state,
			    groups = _state.groups,
			    currentTab = _state.currentTab;

			var currentGroup = groups[currentTab];
			currentGroup.definition = JSON.stringify(currentGroup.definition);

			var id = currentGroup.id;

			var url = location.origin + '/ajax/access' + (id ? '/' + id : '');
			_request2.default.post({
				url: url,
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': CSRF_TOKEN
				},
				form: currentGroup
			}, function (err, response, body) {
				var group = JSON.parse(body);
				this.setState({
					groups: [].concat(_toConsumableArray(groups.slice(0, currentTab)), [group], _toConsumableArray(groups.slice(currentTab + 1)))
				});
			}.bind(this));
		}
	}]);

	return ACS;
}(_react2.default.Component);

exports.default = ACS;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/acs/ACS.js
// module id = 511
// module chunks = 0